import { patch, post } from './api';
import URLS from '@/constants/api';

export const changePassword = async (data: any) => {
  const response = await patch(URLS.CHANGE_PASSWORD, data);
  return response;
};
